/* RESPONSIBLE TEAM: team-actions */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    samlAccount: {
      serialize: 'records',
      deserialize: 'records',
    },
    scimSettings: {
      serialize: 'records',
      deserialize: 'records',
    },
    conversationDeletionSchedule: {
      serialize: 'records',
      deserialize: 'records',
    },
  },

  serialize(snapshot, options) {
    let json = this._super(snapshot, options);
    // Read redaction rules from adapterOptions, which bypasses Ember Data's
    // unreliable @attr array dirty-tracking entirely. The model's save()
    // passes pending rules here via adapterOptions — a first-class Ember Data API.
    if (snapshot.adapterOptions?.pendingRedactionRules) {
      json.conversation_redaction_rules = snapshot.adapterOptions.pendingRedactionRules;
    }
    return json;
  },
});
